import * as actions from "./actions";

const setNavigation = actions.setNavigation;

export default { setNavigation };
